import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'xilo-mono-simple-form-viewer-input-wrapper-panel',
  templateUrl: './table-input-wrapper.component.html',
  styleUrls: ['./table-input-wrapper.component.scss'],
})
export class TableInputWrapperComponent extends FieldWrapper {
  generateLabel() {
    this.to.label = null;
  }
}
